'use client'
import React from 'react';
import styled from "styled-components";
import {Col, Container, Row} from "react-bootstrap";
import {Img} from "@/components/Img";
import parser from "html-react-parser";
import {Parallax, ParallaxProvider} from "react-scroll-parallax";

const MyComponent = ({data}) => {

    return (
        <StyledComponent className={'parallax-img horizontal-scroll pt-120 pb-120'} data-speed-right={30} data-speed-left={-30}>
            <Container className="profile">
                <ParallaxProvider>
                    <Row>
                        <Col md={5} className={'profile-left'}>
                            {/*<div className="fixed-text-top parallax-x">*/}
                            {/*    <h2>{parser(data?.top_text)}</h2>*/}
                            {/*</div>*/}
                            <div className="profile__image ">
                                <Img src={data?.image} parallax alt={data?.designation}/>
                            </div>
                            {/*<div className="fixed-text-bottom ">*/}
                            {/*    <h2 className={'parallax-xr'}>{parser(data?.bottom_text)}</h2>*/}
                            {/*</div>*/}

                        </Col>
                        <Col md={{span: 6, offset: 1}} className="profile__body">
                                        <div className={'profile__body__inner'}>
                                            <div className="profile__body__name">
                                                {
                                                    data?.title &&
                                                    <h4 className={'split-up'}>{parser(data?.title)}</h4>

                                                }
                                                {
                                                    data?.designation &&
                                                    <p className={'split-up'}>{parser(data?.designation)}</p>
                                                }

                                            </div>
                                            {
                                                data?.description &&
                                                parser(data?.description)}

                                        </div>
                                    </Col>
                    </Row>
                </ParallaxProvider>
            </Container>
        </StyledComponent>
    );
};

const StyledComponent = styled.section`
    overflow: hidden;
    background-color: #F9F9F9;
    position: relative;
    .fixed-text-top{
        position: absolute;
        top: -20px;
        left: 40%;
    }
    .fixed-text-bottom{
     
    }

    .profile {
        &__body {
            &__name {
                padding-bottom: 60px;
                @media (max-width: 767px) {
                    margin-top: 60px !important;
                }

                h4 {
                    font-size: 40px;
                    line-height: 60px;
                }

                p {
                    font-size: 14px;
                    line-height: normal;
                    font-weight: 500;
                }
            }

            &__inner {
                padding-bottom: 40px;

            }
        }

        &__image {
            position: relative;
            padding-top: calc(550 / 470 * 100%);
        }
    }

    .profile-left {
        h2 {
            font-size: 60px;
            line-height: 80px;
            color: rgba(19, 23, 25, 0.1);
            font-weight: 800;
            margin-bottom: -30px;

            &:last-child {
                margin-top: -30px;
                z-index: -1;
            }
        }

        //padding-right: 70px;
    }

    .row:nth-child(even) {
        flex-direction: row-reverse;
        justify-content: space-between;
    }


    @media (max-width: 767px) {
        .profile-left {
            padding-right: 15px;
        }

        .profile {
            padding-bottom: unset;

            &__body {
                padding-bottom: unset;

                &__name {
                    padding-bottom: 40px;
                }
            }
        }
    }

    .bg-text-one, .bg-text-two {
        font-size: 200px;
        line-height: 286px;
        font-weight: 700;
        margin: 0;
        color: #252525;
        opacity: 0.05;
        position: absolute;
        white-space: nowrap;


        @media (max-width: 767px) {
            font-size: 120px;
            line-height: 120px;
        }
    }

    .bg-text-one {
        left: -15%;
        top: 45%;

        @media (max-width: 767px) {
            bottom: 120px;
        }
    }

    .bg-text-two {
        right: -15%;
        bottom: 0;
    }

`;

export default React.memo(MyComponent);
